<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'HCP Approval Cycle' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>

      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">

        <div class="row padding-sm-vr" *ngFor="let level of approvalCycle; let i = index">
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (lev.dirty || lev.touched || f.submitted)  && lev.valid, 'has-error' : (lev.dirty || lev.touched || f.submitted)  && lev.invalid}">
              <label class="control-label">{{'repActivities.level' | translate}} </label>

              <input class="form-control" type="number" placeholder="{{'repActivities.level' | translate}}"
                     name="lev{{i}}" #lev="ngModel" required="required" min="1"
                     [(ngModel)]="level.stepLevel">
              <div *ngIf="(lev.dirty || lev.touched || f.submitted)  && lev.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (approvalAct.dirty || approvalAct.touched || f.submitted)  && approvalAct.valid, 'has-error' : (approvalAct.dirty || approvalAct.touched || f.submitted)  && approvalAct.invalid}">
              <label class="control-label">{{'repActivities.type' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="activityApprovalActorkeys"
                            placeholder="{{'repActivities.type' | translate}}"
                            emptyFilterMessage="No results found" required="required"
                            styleClass="wid100"
                            [styleClass]="form-control"
                            name="approvalAct{{i}}"
                            #approvalAct="ngModel" (onChange)="onChangeApprovalActorType(level)"
                            [(ngModel)]="level.activityApprovalActorTypeData"
                            [filter]="true" optionLabel="name">


                </p-dropdown>
              </span>
              <div *ngIf="(approvalAct.dirty || approvalAct.touched || f.submitted)  && approvalAct.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showUsers">
            <div [ngClass]="{'has-success': (visitAssistants.dirty || visitAssistants.touched || f.submitted)  && visitAssistants.valid, 'has-error' : (visitAssistants.dirty || visitAssistants.touched || f.submitted)  && visitAssistants.invalid}">
              <label class="control-label">{{'repActivities.users' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="users"
                            name="visitAssistants{{i}}" #visitAssistants="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="User"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="fullName"></p-dropdown>

              </span> <div *ngIf="(visitAssistants.dirty || visitAssistants.touched || f.submitted)  && visitAssistants.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showRoles">
            <div [ngClass]="{'has-success': (rol.dirty || rol.touched || f.submitted)  && rol.valid, 'has-error' : (rol.dirty || rol.touched || f.submitted)  && rol.invalid}">
              <label class="control-label">{{'repActivities.roles' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="roles"
                            name="rol{{i}}" #rol="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="Role"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span> <div *ngIf="(rol.dirty || rol.touched || f.submitted)  && rol.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showJobs">
            <div [ngClass]="{'has-success': (job.dirty || job.touched || f.submitted)  && job.valid, 'has-error' : (job.dirty || job.touched || f.submitted)  && job.invalid}">
              <label class="control-label">{{'repActivities.jobs' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="jobs"
                            name="job{{i}}" #job="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="Job"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span> <div *ngIf="(job.dirty || job.touched || f.submitted)  && job.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (approvedStatus.dirty || approvedStatus.touched || f.submitted)  && approvedStatus.valid, 'has-error' : (approvedStatus.dirty || approvedStatus.touched || f.submitted)  && approvedStatus.invalid}">
              <label class="control-label">{{'repActivities.approvedStatus' | translate}} </label>

              <input class="form-control" type="text" placeholder="{{'repActivities.approvedStatus' | translate}}"
                     name="approvedStatus{{i}}" #approvedStatus="ngModel"
                     [(ngModel)]="level.approvedStatusText">
              <div *ngIf="(approvedStatus.dirty || approvedStatus.touched || f.submitted)  && approvedStatus.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (rejectedStatus.dirty || rejectedStatus.touched || f.submitted)  && rejectedStatus.valid, 'has-error' : (rejectedStatus.dirty || rejectedStatus.touched || f.submitted)  && rejectedStatus.invalid}">
              <label class="control-label">{{'repActivities.rejectedStatus' | translate}} </label>

              <input class="form-control" type="text" placeholder="{{'repActivities.rejectedStatus' | translate}}"
                     name="rejectedStatus{{i}}" #rejectedStatus="ngModel"
                     [(ngModel)]="level.rejectedStatusText">
              <div *ngIf="(rejectedStatus.dirty || rejectedStatus.touched || f.submitted)  && rejectedStatus.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-2 left-7 cursor-pointer" style="margin-top:30px;" (click)="removeLevel(i)">
            <span class="margin-right-7 create-new-span">
              Remove
            </span>
            <i class="fa fa-minus-circle"></i>
          </div>
        </div>
        <div class="row padding-xs-vr">
          <div class="col-sm-9"></div>
          <div class="col-sm-2 left-7 cursor-pointer" style="margin-top:30px;" (click)="addNewLevel()">
            <span class="margin-right-7 create-new-span">Add Level</span>
            <i class="fa fa-plus-circle"></i>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="getApprovalCycle()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit">{{'app.save' | translate}}</button>
        </div>
      </form>
    </div>

  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>


